import React, { Component, forwardRef } from 'react';
import { Link, Redirect } from 'react-router-dom';
import MaterialTable from 'material-table';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Loader from '../../../Loader.js';
import Rodal from 'rodal';
import 'rodal/lib/rodal.css';
import Paper from '@material-ui/core/Paper';
import Form from 'react-bootstrap/Form';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Button from '@material-ui/core/Button';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { LocalizationTheme } from '../../../../utils/utils.js';
import { DisplayMessage } from '../../../../services/helpers.js';
import FontDownloadRoundedIcon from '@material-ui/icons/FontDownloadRounded';
import { DeleteForever } from '@material-ui/icons';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import { sortTableBooleans, sortTableColors, sortTableStringsNotCaseSensitive } from '../../../../utils/tableSorting.js';
import ColorChip from '../../../Common/ColorChip/ColorChip.js';
import appFetch from '../../../../api/appFetch.js';
import { TagsWithIdV1Url, TagsWithTypeUrl } from '../../../../constants/apiUrls.js';
import { isValidColor } from '../../../../utils/isValidColor.js';
import EnhancedDropdownComponent from '../../../Common/Dropdowns/EnhancedDropdownComponent.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
    FontDownloadRoundedIcon: forwardRef((props, ref) => <FontDownloadRoundedIcon {...props} ref={ref} />)
};

export default class TagsTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            type: 3,
            outletId: 0,
            dataGrid: [],
            currenttagId: this.props.currenttagId,
            tagId: 0,
            fetchingData: true,
            showDelete: false,
            deletedItem: 0,
            accessibleMoboOutlets: [],
            editedtagId: undefined,
            editedTag: undefined,
            showEditTag: false,
            requestInProgress: false,
            tags: []
        };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.refreshGrid && newProps.outletId !== undefined) {
            this.setState({ outletId: newProps.outletId, type: parseInt(newProps.type) });
            this.getData(newProps.outletId, parseInt(newProps.type));
        } else {
            if (newProps.refreshGrid) {
                this.getData();
            }
        }

        this.setState({ redirect: null });
    }

    componentDidMount() {
        this.getData();
    }

    getData = (outletId, typeId) => {
        this.setState({ fetchingData: true });
        let initialData = {};
        var resources = this.props.resources;
        var accessibleMoboOutlets = this.props.accessibleMoboOutlets;
        var moboOutletId = outletId != undefined ? outletId : this.state.outletId;
        var type = typeId != undefined ? typeId : this.state.type;
        var url = "";

        initialData.columns = [
            {
                title: resources["Color"],
                field: 'colorHex',
                width: "15%",
                render: rowData => <ColorChip colorHex={rowData.colorHex} id={isValidColor(rowData.colorHex) ? `color-${rowData.colorHex}-${rowData.id}` : `color-none-${rowData.id}`} />,
                customSort: (a, b) => sortTableColors(a.colorHex, b.colorHex)
            },
            {
                title: resources["Outlet"],
                width: "20%",
                field: 'moboOutletDescription',
                filtering: false,
                customSort: (a, b) => sortTableStringsNotCaseSensitive(a.moboOutletDescription, b.moboOutletDescription)
            },
            {
                title: resources["Description"],
                width: "40%",
                field: 'description',
                filtering: false,
                customSort: (a, b) => sortTableStringsNotCaseSensitive(a.description, b.description)
            },
            {
                title: resources["IsPause"],
                width: "20%",
                field: 'isPause',
                filtering: false,
                customSort: (a, b) => sortTableStringsNotCaseSensitive(a.isPause, b.isPause)
            },
            {
                title: resources["IsVisibleInPlanning"],
                width: "20%",
                field: 'isVisibleInPlanning',
                filtering: false,
                sortable: true,
                lookup: { true: resources["True"], false: resources["False"] },
                customSort: (a, b) => sortTableBooleans(a.isVisibleInPlanning, b.isVisibleInPlanning)
            },
        ];

        initialData.actions = [
            {
                icon: () => <Edit />,
                tooltip: resources["Edit"],
                onClick: (event, rowData) => this.setState({ redirect: `tags/${rowData.id}`, editedtagId: rowData.id })
            },

            rowData => (!rowData.isDeletedValue && rowData.id === this.state.currenttagId ? {
                icon: () => <DeleteForever />,
                tooltip: resources["YouCantDeleteTag"],

            } : null),

            rowData => (!rowData.isDeletedValue && rowData.id !== this.state.currenttagId ? {
                icon: () => <DeleteOutline />,
                tooltip: resources["Delete"],
                onClick: () => this.handleShowDelete(rowData.id),
            } : null),
        ]

        url = TagsWithTypeUrl(type);

        if (moboOutletId != undefined && moboOutletId != 0) {
            url = url + `&moId=` + moboOutletId + `&settings=true`;
        }

        appFetch({
            url: url,
            onSuccess: (data) => {
                const currentRows = [];
                const tags = [];

                data.sort((el1, el2) => el1.id - el2.id).forEach(function (rowData) {
                    const moboOutlet = rowData.moboOutletId !== undefined && rowData.moboOutletId !== null ? accessibleMoboOutlets.find(x => x.id === rowData.moboOutletId) : null;
                    const moboOutletDesc = moboOutlet !== undefined && moboOutlet !== null ? moboOutlet.description : "";

                    tags.push(rowData);

                    currentRows.push({
                        id: rowData.id,
                        colorHex: rowData.colorHex,
                        moboOutletDescription: moboOutletDesc,
                        description: rowData.description,
                        isPause: rowData.isPause ? resources["Yes"] : resources["No"],
                        isVisibleInPlanning: rowData.isVisibleInPlanning
                    });
                });

                initialData.data = currentRows;

                this.setState({
                    dataGrid: initialData,
                    tags: tags
                });
            },
            onError: (data) => {

            },
            onFinalize: () => {
                this.setState({ fetchingData: false });
            }
        })
    }

    handleCloseDelete = () => {
        this.setState({ showDelete: false, deletedItem: 0 });
    }

    handleShowDelete = (itemId) => {
        this.setState({ showDelete: true, deletedItem: itemId });
    }

    handleDeleteTag = () => {
        if (this.state.deletedItem > 0) {
            let resources = this.props.resources;
            this.setState({ requestInProgress: true });
            const url = TagsWithIdV1Url(this.state.deletedItem);

            appFetch({
                url: url,
                method: 'DELETE',
                onSuccess: () => {
                    DisplayMessage(resources["TagWasDeleted"], "success");
                    this.getData();
                    this.setState({ showDelete: false, deletedItem: 0 });
                    this.handleCloseDelete();
                },
                onError: (data, response) => {
                    if (response.statusText.length > 0) {
                        DisplayMessage(response.statusText, "error");
                    }

                    for (let i = 0; i < data.errors.length; i++) {
                        DisplayMessage(data.errors[i], "error");
                    }
                },
                onFinalize: () => {
                    this.setState({ requestInProgress: false });
                }
            })
        }
    }

    handleChangeOutlet = e => {
        this.setState({ outletId: parseInt(e.target.value) }, () => this.getData(this.state.outletId));
    };

    handleTypeChange = e => {
        this.setState({ [e.target.name]: parseInt(e.target.value) }, () => this.getData(this.state.outletId));
    };

    render() {
        const { redirect, fetchingData, type, editedtagId, outletId } = this.state;
        const { resources } = this.props;

        if (redirect) {
            return (<Redirect to={{
                pathname: redirect,
                state: { editedtagId: editedtagId, editedTag: this.state.tags.find(t => t.id === editedtagId), refreshGrid: true }
            }}
            />)
        }

        return (
            <div>
                <div className="position-relative py-4">
                    <h3>{resources["TagsTitle"]}</h3>
                    <div className={"offcentered-loader " + (fetchingData ? 'fadeIn' : 'fadeOut')}><CircularProgress /></div>

                    <div className={"mt-4 " + (fetchingData ? 'fadeOut' : 'fadeIn')}>
                        <Form.Group className="main-dropdown">
                            <OutletsDropdown
                                resources={resources}
                                outlets={this.props.accessibleMoboOutlets}
                                outlet={outletId}
                                onOutletChange={this.handleChangeOutlet}
                                id="outlet-dropdown-grid"
                                containerClass="col-md-12"
                            />
                        </Form.Group>
                        <div style={{ clear: "both", }}></div>
                        <Form.Group className="main-dropdown">
                            <div className="col-md-12" style={{ padding: 0 }}>
                                <EnhancedDropdownComponent
                                    id="type-dropdown-grid"
                                    labelText={resources["Type"]}
                                    value={type}
                                    options={[
                                        { key: 3, name: resources["Dossiers"] },
                                        { key: 4, name: resources["RepairOrderItems"] },
                                        { key: 5, name: resources["Warranty"] },
                                    ]}
                                    inputName="type"
                                    handleChange={this.handleTypeChange}
                                    addMarginBottom={false}
                                />
                            </div>
                        </Form.Group>
                        <div style={{ float: "right", marginBottom: "10px" }}>
                            <Link to={{ pathname: "/tags/new", state: { tagId: this.state.tagId, accessibleMoboOutlets: this.state.accessibleMoboOutlets, outletId: outletId, type: type } }} style={{ textDecoration: 'none' }}>
                                <Button id="add-tag" variant="contained" color="primary">
                                    <i className="fas fa-plus mr-2" title={resources["AddNewTag"]} />
                                    {resources["AddNewTag"]}
                                </Button>
                            </Link >
                        </div>
                        <div style={{ clear: "both", }}></div>

                        <Paper elevation={3} className="p-3 mt-3">
                            <MuiThemeProvider theme={LocalizationTheme()}>
                                <MaterialTable
                                    icons={tableIcons}
                                    title={""}
                                    localization={{
                                        header: { actions: resources["Actions"] },
                                        body: {
                                            emptyDataSourceMessage: resources["NoRecordsToBeDisplayed"],
                                            deleteTooltip: resources["DeleteTooltip"],
                                            editTooltip: resources["EditTooltip"],
                                        },
                                        toolbar: {
                                            searchPlaceholder: resources["Search"],
                                            searchTooltip: resources["Search"]
                                        },
                                        pagination: {
                                            firstTooltip: resources["FirstTooltip"],
                                            lastTooltip: resources["LastTooltip"],

                                            previousTooltip: resources["PreviousTooltip"],
                                            nextTooltip: resources["NextTooltip"],

                                            labelRowsPerPage: resources["LabelRowsPerPage"],
                                            labelRowsSelect: resources["LabelRowsSelect"],
                                        }
                                    }}
                                    data={this.state.dataGrid.data}
                                    columns={this.state.dataGrid.columns}
                                    actions={this.state.dataGrid.actions}
                                    options={{
                                        emptyRowsWhenPaging: false, pageSize: 10, pageSizeOptions: [10, 15, 20]
                                    }}
                                />
                            </MuiThemeProvider>
                        </Paper>
                    </div>
                    <div className={"loader-overlap position-absolute " + (this.state.fetchingData ? 'fadeIn' : 'fadeOut')}><div className="container"><Loader /></div></div>

                    <Rodal visible={this.state.showDelete} onClose={this.handleCloseDelete} className="rodal" customStyles={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'
                    }}>
                        <div className="modal-body" style={{ marginTop: "20px", display: "flex", alignItems: "center" }}>{resources["AreYouSureYouWantToDeleteTag"]}</div>
                        <div className="modal-footer" style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                            <button className="btn btn-secondary" id="btnCancelDelete" style={{ backgroundColor: "white", color: "#53B3EA", borderColor: "#53B3EA" }}
                                onClick={this.handleCloseDelete} disabled={this.state.requestInProgress}>{resources["Cancel"]}</button>
                            <button className="btn btn-primary" id="btnDelete" style={{ backgroundColor: "#53B3EA", color: "white", borderColor: "#53B3EA" }}
                                onClick={this.handleDeleteTag} disabled={this.state.requestInProgress}>{resources["Yes"]}</button>
                        </div>
                        <span className="rodal-close"></span>
                    </Rodal>
                </div>
            </div >
        )
    };
}